import { Children, ReactNode } from "react";

import { RightOutlined } from "@ant-design/icons";
import { cx } from "class-variance-authority";

import chevronRightSvg from "../../img/chevron-right.svg";
import { Svg } from "../../utils/svgIcon";

import {
    ApplicationBarVariant,
    useApplicationBarVariant,
} from "./ApplicationBarVariant";
import * as theme from "./Breadcrumbs.css";

export interface BreadcrumbsProps {
    /**
     * `BreadcrumbsHome`, then a `BreadcrumbsLabel` per page, each inside the
     * caller's link when the page has one.
     */
    children: ReactNode;
}

export function Breadcrumbs({ children }: BreadcrumbsProps) {
    const variant = useApplicationBarVariant();

    return (
        <nav className={cx(theme.breadcrumbs, theme.breadcrumbsSize[variant])}>
            <ol className={theme.list}>
                {Children.toArray(children).map((crumb, index) => (
                    <li key={index} className={theme.crumb}>
                        {index > 0 && separators[variant]}
                        {crumb}
                    </li>
                ))}
            </ol>
        </nav>
    );
}

const separators: Record<ApplicationBarVariant, ReactNode> = {
    default: <RightOutlined className={theme.defaultSeparator} />,
    flat: <Svg src={chevronRightSvg} className={theme.flatSeparator} />,
};
